
export default {
	title: "404 - Page Not Found!",
	subTitle: "Whoops, looks like this page does not exist.",
	background: {
		sky: {
			day: '#a5def7',
			night: '#272727',
			stormy: '#717171'
		},
		mountains: {
			back: 0.1,
			mid: 0.2,
		 	front: 0.3
		},
		road: 0.7,
		houses: 0.7,
		clouds: {
			count: {
				max: 30,
				min: 10,
			},
			speed: {
				max: 50,
				min: 25
			},
			opacity: {
				max: 90,
				min: 50
			}
		},
		rain: {
			scale: {
				min: 0.1, 
				max: 0.5
			},
			speed: {
				min: 300,
				max: 500
			},
			gravityY: 200
		}
	}
};